import { Link } from 'react-router-dom';
import { featuredArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
              编辑精选
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              不容错过的优质内容推荐
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {featuredArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className={`group rounded-lg overflow-hidden bg-background-50 hover:bg-background-200/50 transition-all duration-300 cursor-pointer ${
                index === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`overflow-hidden ${index === 0 ? 'aspect-[16/9]' : 'aspect-[16/10]'}`}>
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-accent-100 text-accent-700">
                  {article.categoryName}
                </span>
                <h3 className={`mt-3 font-heading text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 ${
                  index === 0 ? 'text-xl md:text-2xl' : 'text-lg'
                }`}>
                  {article.title}
                </h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-4 text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.viewCount.toLocaleString()}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-heart-line"></i>
                    {article.likeCount.toLocaleString()}
                  </span>
                  <span>{article.readTime}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}